import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useAsyncRetry} from 'react-use';
import {Spin} from 'antd';

import {ClientAppStoreProvider, useClientAppStore} from './index';
import {getClientApp} from '@/api/clientApps';

ClientAppInner.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    children: PropTypes.node,
};

function ClientAppInner({clientAppId, children}) {
    const [, dispatch] = useClientAppStore();
    const {loading, value, retry} = useAsyncRetry(() => {
        return getClientApp(clientAppId);
    }, [clientAppId]);
    console.log('ClientAppPage loading, value', loading, value);
    const clientApp = value?.data ?? {};

    useEffect(() => {
        if (loading) {
            return;
        }

        dispatch(['initClientApp', {clientAppId, clientApp, reload: retry}]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, clientAppId]);

    return <Spin spinning={loading}>{children}</Spin>;
}

ClientAppContainer.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    children: PropTypes.node,
};

function ClientAppContainer({clientAppId, children}) {
    return (
        <ClientAppStoreProvider>
            <ClientAppInner clientAppId={clientAppId}>{children}</ClientAppInner>
        </ClientAppStoreProvider>
    );
}

export default ClientAppContainer;
